<template>
    <a :href="`https://www.chinaplasonline.com/eMarketplace/Supplier/${langCode}?scroll=supplier_MembershipsBenefits`" target="_blank" t_label="EMPBE_Sale_Lead_unlockToView">
        <div class="unlock-btn-container">
            <div class="unlock-btn">
                <i class="unlock-btn-svg">
                    <img src="https://cdn.adsalecdn.com/EMP/2-0/NameCard/SalesLead_Unlock.svg" alt="解锁" width="20" height="21" />
                </i>
                <span class="unlock-btn-text">{{$t("lbl_EMPBE_SalesLead_Unlock")}}</span>
            </div>
        </div>
    </a>
</template>
<script>
    export default{
        computed:{
            langId(){
                return localStorage.getItem("currentLangId")
            },
            langCode(){
                return localStorage.getItem("currentLang")
            }
        }
    }
</script>
<style lang="scss">
    .unlock-btn-container{
        display: flex;
        align-items: flex-start;

        .unlock-btn{
            display: flex;
            padding: 8px;
            align-items: center;
            border-radius: 4px;
            border: 1px solid #7968FF;

            .unlock-btn-svg{
                width: 20px;
                height: 19.999px;
            }
            .unlock-btn-text{
                display: flex;
                padding: 0px 4px;
                justify-content: center;
                align-items: center;
                gap: 10px;
                color: #7968FF;
                text-align: center;
                font-weight: bold;
                
                font-size: 14px;
                font-style: normal;
                line-height: 150%; /* 21px */
                letter-spacing: -0.154px;
            }
        }
    }
</style>